import useLocalStorage from "helpers/useLocalStorage";

export const authState = () => {
  const [isLogin, setIsLogin] = useLocalStorage("@isLogin", false);
  return {
    isLogin,
    setIsLogin,
  };
};
